export const normalizeRepToken = (token, allowedKeywords = ['AMAP']) => {
  if (typeof token !== 'string') {
    return { isValid: false, value: token };
  }

  const cleaned = token.trim();

  if (/^\d+\+?$/.test(cleaned)) {
    return { isValid: true, value: cleaned };
  }

  // Ranges may descend (e.g. 8-4) — coaches use that form for drop sets.
  if (/^\d+-\d+$/.test(cleaned)) {
    return { isValid: true, value: cleaned };
  }

  const upper = cleaned.toUpperCase();
  if (allowedKeywords.includes(upper)) {
    return { isValid: true, value: upper };
  }

  return { isValid: false, value: cleaned };
};

export const normalizeRepArray = (values, allowedKeywords = ['AMAP']) => {
  // Treat non-array input as invalid (rather than silently coercing to []) so
  // upstream type bugs surface instead of being masked as "valid empty".
  if (!Array.isArray(values)) {
    return {
      isValid: false,
      values: [],
      invalidValues: [{ value: values, position: null }],
    };
  }

  const invalidValues = [];
  const normalized = values.map((rep, index) => {
    const result = normalizeRepToken(rep, allowedKeywords);
    if (!result.isValid) {
      invalidValues.push({ value: rep, position: index + 1 });
    }
    return result.value;
  });

  return {
    isValid: invalidValues.length === 0,
    values: normalized,
    invalidValues,
  };
};

export default normalizeRepToken;
